(function () {
  function isExternalLink(link) {
    if (!link || !link.href) return false;

    const href = link.getAttribute('href');
    if (!href) return false;

    if (
      href.startsWith('#') ||
      href.startsWith('/') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return false;
    }

    try {
      const url = new URL(link.href, window.location.origin);
      return url.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function processLinks(scope) {
    const links = (scope || document).querySelectorAll('a[href]');

    links.forEach(function (link) {
      if (isExternalLink(link)) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      }
    });
  }

  function init() {
    processLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('a[href]')) {
            processLinks(node.parentNode || document);
          } else if (node.querySelectorAll) {
            processLinks(node);
          }
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();